import { useContext } from "react";
import SwitchTitleDescription from "./common/SwitchTitleDescription";
import { Input } from "@/components/ui/input";
import InputTitleDescription from "./common/InputTitleDescription";
import SimpleSelect from "@/components/ui/simple-select";
import BlockIconSelector from "./BlockIconSelector";
import GraphConfigFormContext from "@/store/contexts/GraphConfigFormContext";
import { useTranslation } from "react-i18next";

const TableBlockDisplay = () => {
  const { config, setConfig } = useContext(GraphConfigFormContext);
  const { t } = useTranslation();

  if (!config) return null;

  if (config.type === "block") {
    return (
      <div className="flex flex-col w-full px-4 pt-4 pb-[100px]">
        <div className="flex flex-col w-full gap-4">
          {/* <InputTitleDescription
            title="Block Size"
            description="Display size for the block"
          >
            <SimpleSelect
              className="w-2/5"
              value={config.block_options.size}
              options={[
                { value: "small", label: "Small" },
                { value: "medium", label: "Medium" },
                { value: "large", label: "Large" },
              ]}
              onChange={(value) =>
                setConfig(
                  {
                    ...config,
                    block_options: {
                      ...config.block_options,
                      size: value as "small" | "medium" | "large",
                    },
                  },
                  true
                )
              }
            />
          </InputTitleDescription> */}
          <InputTitleDescription
            title={t("editor.graphConfig.tableBlock.prefix")}
            description={t("editor.graphConfig.tableBlock.prefixDescription")}
          >
            <Input
              type="text"
              className="w-2/5"
              placeholder={t("editor.graphConfig.tableBlock.prefixPlaceholder")}
              value={config.block_options.prefix}
              onChange={(e) =>
                setConfig({
                  ...config,
                  block_options: {
                    ...config.block_options,
                    prefix: e.target.value,
                  },
                })
              }
            />
          </InputTitleDescription>
          <InputTitleDescription
            title={t("editor.graphConfig.tableBlock.suffix")}
            description={t("editor.graphConfig.tableBlock.suffixDescription")}
          >
            <Input
              type="text"
              className="w-2/5"
              placeholder={t("editor.graphConfig.tableBlock.suffixPlaceholder")}
              value={config.block_options.suffix}
              onChange={(e) =>
                setConfig({
                  ...config,
                  block_options: {
                    ...config.block_options,
                    suffix: e.target.value,
                  },
                })
              }
            />
          </InputTitleDescription>
          <InputTitleDescription
            title={t("editor.graphConfig.tableBlock.format")}
            description={t("editor.graphConfig.tableBlock.formatDescription")}
          >
            <SimpleSelect
              className="w-2/5"
              value={config.block_options.format}
              options={[
                { value: "number", label: t("editor.graphConfig.tableBlock.formatTypes.number") },
                { value: "decimal", label: t("editor.graphConfig.tableBlock.formatTypes.decimal") },
                { value: "percent", label: t("editor.graphConfig.tableBlock.formatTypes.percent") },
                { value: "currency", label: t("editor.graphConfig.tableBlock.formatTypes.currency") },
                { value: "compact", label: t("editor.graphConfig.tableBlock.formatTypes.compact") },
              ]}
              onChange={(value) =>
                setConfig(
                  {
                    ...config,
                    block_options: {
                      ...config.block_options,
                      format: value as
                        | "number"
                        | "decimal"
                        | "percent"
                        | "currency"
                        | "compact",
                    },
                  },
                  true
                )
              }
            />
          </InputTitleDescription>
          <InputTitleDescription
            title={t("editor.graphConfig.tableBlock.decimals")}
            description={t("editor.graphConfig.tableBlock.decimalsDescription")}
          >
            <Input
              type="number"
              className="w-2/5"
              min={0}
              max={10}
              value={config.block_options.decimals}
              onChange={(e) =>
                setConfig({
                  ...config,
                  block_options: {
                    ...config.block_options,
                    decimals: Number(e.target.value),
                  },
                })
              }
            />
          </InputTitleDescription>
          <InputTitleDescription
            title={t("editor.graphConfig.tableBlock.icon")}
            description={t("editor.graphConfig.tableBlock.iconDescription")}
          >
            <BlockIconSelector
              value={config.block_options.icon}
              onChange={(value) =>
                setConfig(
                  {
                    ...config,
                    block_options: {
                      ...config.block_options,
                      icon: value,
                    },
                  },
                  true
                )
              }
            />
          </InputTitleDescription>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full px-4 pt-4 pb-[100px]">
      <div className="flex flex-col w-full gap-4">
        <InputTitleDescription
          title={t("editor.graphConfig.tableBlock.pageSize")}
          description={t("editor.graphConfig.tableBlock.pageSizeDescription")}
        >
          <Input
            type="number"
            className="w-2/5"
            placeholder={t("editor.graphConfig.tableBlock.pageSizePlaceholder")}
            value={config.table_options.pageSize || ""}
            onChange={(e) =>
              setConfig({
                ...config,
                table_options: {
                  ...config.table_options,
                  pageSize: Number(e.target.value),
                },
              })
            }
          />
        </InputTitleDescription>
        <SwitchTitleDescription
          title={t("editor.graphConfig.tableBlock.stripped")}
          description={t("editor.graphConfig.tableBlock.strippedDescription")}
          value={config.table_options.styling.striped}
          onChange={(checked: boolean) =>
            setConfig({
              ...config,
              table_options: {
                ...config.table_options,
                styling: {
                  ...config.table_options.styling,
                  striped: checked,
                },
              },
            })
          }
        />
        <SwitchTitleDescription
          title={t("editor.graphConfig.tableBlock.highlightOnHover")}
          description={t("editor.graphConfig.tableBlock.highlightOnHoverDescription")}
          value={config.table_options.styling.highlightHover}
          onChange={(checked: boolean) =>
            setConfig({
              ...config,
              table_options: {
                ...config.table_options,
                styling: {
                  ...config.table_options.styling,
                  highlightHover: checked,
                },
              },
            })
          }
        />
      </div>
    </div>
  );
};

export default TableBlockDisplay;
